import axios from "axios";

export default (brandId, data) => axios.post(`/send-data-export/${brandId}`, data);
